export namespace PERMISSIONS {

    export namespace user {
        export const CRO = ['auth.manage_role_cro']
        export const GENERIC = ['auth.readonly_user']
        export const MANAGEMENT_LEAD = ['auth.management_lead']
        export const STF = ['auth.manage_role_stf']
        export const LOCAL_STF = ['auth.manage_role_local_stf']
        export const FS = ['auth.manage_role_fs']
        export const RESISTANCE_SAMPLING_LAB_FS = ['auth.manage_role_resistance_sampling_lab']
        export const DLO = ['auth.manage_role_cro_manager']
        export const RTM = ['auth.manage_role_rtm']
        export const SEEDCARE_RTM_SUPPORT = ['auth.manage_role_seedcare_rtm_support']

        export const ACTIVITY_COUNTRY_LEAD = ['auth.manage_role_ttl_activity_planner']
        export const SAMPLING_COUNTRY_LEAD = ['auth.manage_role_ttl_sampling']

        export const FROST_FS_COUNTRY_LEAD = ['auth.manage_role_ttl_frost']

        export const EQUIPMENT_COUNTRY_ADMIN = ['auth.manage_role_ttl_equipment_stock']

        export const SEEDCARE_COUNTRY_LEAD = ['auth.manage_role_ttl_seedcare']

        export const SOIL_SENSOR_COUNTRY_ADMIN = ['auth.manage_role_ttl_soil_sensor']

        export const SYSTEM = ['auth.manage_system']
        export const MANAGE_FROST = ['auth.manage_app_frost']
        export const ADMIN_ACTIVITY = ['auth.manage_app_activity_planner']
        export const ADMIN_EQUIPMENT = ['auth.manage_app_digital_inv']
        export const ADMIN_SEEDCARE = ['auth.manage_app_seedcare']
        export const ADMIN_RESISTANCE_SAMPLING = ['auth.manage_app_resistance_sampling']
        export const ADMIN_DATA_QUALITY = ['auth.manage_app_dqrt']
        export const MANAGE_CHEMICALS=['auth.manage_app_chemical_inv']

        // Generic

        export const ACTIVITY_GENERIC = ['auth.manage_role_generic_activity_planner']
        export const DATA_QUALITY_GENERIC = ['auth.manage_role_generic_dqrt']
        export const CHEMICALS_GENERIC = ['auth.manage_role_generic_chemical_inv']
        export const RESISTANCE_SAMPLING_GENERIC = ['auth.manage_role_generic_resistance_sampling']
        export const EQUIPMENT_GENERIC = ['auth.manage_role_generic_digital_inv']
        export const FROST_GENERIC = ['auth.manage_role_generic_frost']
        export const SEEDCARE_GENERIC = ['auth.manage_role_generic_seedcare']

        // Other
        export const DATA_QUALITY_MANAGER = ['auth.manage_role_dqrt_manager']

        export const ADMIN_SOIL_SENSOR = ['auth.manage_app_soil_sensor']
        export const SOIL_SENSOR_GENERIC = ['auth.manage_role_generic_soil_sensor']
        export const SOIL_SENSOR_PROVIDER = ['auth.manage_role_soil_sensor_provider']

    }

    export namespace SoilSensor {
        export const PERMISSIONS = ['auth.access_app_soil_sensor']
        export const READONLY = ['auth.readonly_soil_sensor']
        export const ADMINISTRATE = ['auth.administrate_soil_sensor_app']
        export const MANAGE_COUNTRY = ['auth.manage_country_soil_sensor']
        export const ANY_PERMISSIONS = [
            ...PERMISSIONS,
            ...READONLY,
            ...ADMINISTRATE,
            ...MANAGE_COUNTRY,
            ...user.SOIL_SENSOR_GENERIC,
            'auth.add_soil_sensor',
            'auth.access_view_soil_sensor_providers',
            ...user.SOIL_SENSOR_PROVIDER,
        ]

        export namespace ProtocolRequests {
            export const VIEW = ['auth.access_view_soil_sensor_protocol_requests']
            export const CREATE = ['auth.access_create_soil_sensor_protocol_requests']
            export const ANY_PERMISSIONS = [...VIEW, ...CREATE, ...ADMINISTRATE]
        }

        export namespace CreateOrder {
            export const ANY_PERMISSIONS = [
                'auth.access_view_soil_sensor_create_order',
                ...ADMINISTRATE,
                ...MANAGE_COUNTRY,
                user.FS,
                user.DLO,
                user.CRO,
            ]
        }

        export namespace Providers {
            export const PERMISSIONS = ['auth.access_view_soil_sensor_providers']
            export const ANY_PERMISSIONS = [...PERMISSIONS, ...user.SOIL_SENSOR_PROVIDER, ...ADMINISTRATE]
        }

        export namespace SensorsCatalog {
            export const ADD = ['auth.add_soil_sensor']
            export const ANY_PERMISSIONS = [...ADD, ...ADMINISTRATE]
        }

        export namespace AdminSensors {
            export const ANY_PERMISSIONS = [...SensorsCatalog.ADD, ...ADMINISTRATE]
        }
    }

    export namespace FROST {
        export const PERMISSIONS = ['auth.access_app_frost']
        export namespace Ordering {
            export const ANY_PERMISSIONS = ["auth.access_app_frost_ordering"]
            export namespace Assign {
                export const ANY_PERMISSIONS = ["auth.access_view_frost_ordering_cro_assign"]
                export const VIEW_ALL_ASSIGNMENTS = ["auth.view_all_frost_ordering_cro_assign"]
                export const EDIT_CRO_ASSIGNMENT = ["auth.edit_frost_ordering_cro_assign"]
            }
            export namespace Create {
                export const ANY_PERMISSIONS = ["auth.access_view_frost_ordering_create"]
                export const CREATE = ['auth.create_frost_order']
                export const VIEW_FOR_TTL = ['auth.view_frost_ttl_order_create']
                export const VIEW_FOR_COUNTRIES = ['auth.view_frost_all_countries_create']
                export const VIEW_CREATE_CRO = ['auth.view_create_frost_cro_order']
                export const VIEW_CREATE_IH = ['auth.view_create_frost_ih_order']
                export const VIEW_CREATE_BY_CRO_MGR = ['auth.view_create_frost_cro_mngr_order']
            }
            export namespace Report {
                export const ANY_PERMISSIONS = ["auth.access_view_frost_ordering_report"]
                export const DELETE_ORDER = ['auth.delete_frost_order']
                export const SWITCH = ['auth.switch_frost_ordering_report_view']
            }
            export namespace TDManagement {
                export const ANY_PERMISSIONS = ["auth.access_view_frost_demand_mngt"]
            }
            export namespace FlaggedData {
                export const PERMISSIONS = ['auth.access_view_frost_ordering_flagged_data']
            }
        }
        export namespace Reservation {
            export const ANY_PERMISSIONS = ['auth.access_app_frost_reservation']
            export namespace SampleManagement {
                export const ANY_PERMISSIONS = ['auth.access_view_frost_sample_management']
            }
        }

        export namespace Tracking {
            export const ANY_PERMISSIONS = ['auth.access_app_frost_gist']
            export const BULK_IMPORT = ['auth.bulk_import_frost_gist']
            export const EDIT = ['auth.edit_frost_gist']
            export const TOGGLE_RECORD_VISIBILITY = ['auth.toggle_gist_record_visibility']
            export const VIEW_MULTIPLE_COUNTRIES = ['auth.view_gist_multiple_countries']
        }


        export namespace Forecast {
            export const ANY_PERMISSIONS = ["auth.access_app_frost_forecast"]

            export namespace Add {
                export const ANY_PERMISSIONS = ['auth.access_view_add_frost_forecast']
                export const ADD_LATE_FORECAST = ['auth.create_frost_late_forecast']
                export const ADD_TS_FORECAST = ['auth.create_frost_ts_forecast']
                export const ADD_CP_FORECAST = ['auth.create_frost_cp_forecast']
                export const ADD_FORECAST_FOR_ANY_RTM = ['auth.create_frost_forecast_for_all_users']
                export const ADD_FORECAST_FOR_MEMBER_ON_TEAM = ['auth.create_frost_forecast_for_team']
            }
            export namespace View {
                export const ANY_PERMISSIONS = ['auth.access_view_frost_ordering_create']
            }
        }
    }


    export namespace Seedcare {
        export const PERMISSIONS = ['auth.access_app_seedcare']

        export namespace SeedTreatmentApp {
            export const PERMISSIONS = ['auth.access_app_seedcare_seed_treatment']

            export namespace TreatmentRequest {
                export namespace RequestOverview {
                    export const PERMISSIONS = ['auth.view_seed_treatment_overview']
                }
                export namespace RTMRequestTrial {
                    export const PERMISSIONS = ['auth.view_seed_treatment_request_per_trial']
                }
            }


            export namespace AssignedTrials {
                export const PERMISSIONS = ['auth.access_view_seedcare_assigned_trials']
                /**Default CRO Manager */
                export const MANAGE_CRO_TRIAL_ASSIGNEMENT = ['auth.edit_seedcare_cro_trial_assignment']
                export const EDIT_CRO_SHIPPING_ADDR = ['auth.edit_seedcare_cro_shipping_address']
                export const EDIT_IH_SHIPPING_ADDR = ['auth.edit_seedcare_ih_shipping_address']
                /** ADMIN and generic */
                export const ELEVATED_VIEW = ['auth.view_seedcare_elevated_cro_trial_assignment']
                export const VIEW_IH_TTL_TRIAL_ASSIGNEMENT = ['auth.view_seedcare_ttl_trial_assignment']
            }
            export namespace STFProtocolsPerTrial {
                export const PERMISSIONS = ['auth.access_view_seed_treatment_protocols_per_trial']
                export const ELEVATED_VIEW = ['auth.view_seedcare_elevated_protocols_per_trial']
            }
            export namespace STFShipping {
                export const PERMISSIONS = ['auth.access_view_seed_treatment_shipment']
            }
        }

        export namespace InfectedSeedsApp {
            export const ANY_PERMISSIONS = ['seedcare_infected_seeds.view_infectedseed', user.MANAGEMENT_LEAD, ...user.SEEDCARE_GENERIC]
        }
        export namespace TreatmentPlan {
            export const PERMISSIONS = ['auth.access_app_seed_treatment_plan']
        }

        export namespace ProductAssessment {
            export const PERMISSIONS = ['auth.access_app_seed_product_assessment']
        }
        export namespace UPSShipping {
            export const ANY_PERMISSIONS = [user.ADMIN_SEEDCARE]
        }
    }


    export namespace Utilities {
        export const PERMISSIONS = ['auth.access_app_utilities']
        export const ACCESS_TRAINING_LINKS = ['auth.access_training_links']

        export namespace DataQuality {
            export const PERMISSIONS = ['auth.access_app_dqrt']
            export namespace Search {
                export const PERMISSIONS = ['auth.access_view_dqrt_search']
            }
            export namespace Overview {
                export const PERMISSIONS = ['auth.access_view_dqrt_overview']
            }
            export namespace Review {
                export const PERMISSIONS = ['auth.access_view_dqrt_review']
                export const CREATE_ADHOC = ['auth.create_dqrt_adhoc_flag']
                export const VIEW_MAPPING = ['auth.view_dqrt_column_mapping']
                export const EDIT_MAPPING = ['auth.edit_dqrt_column_mapping']
            }
            export namespace Audit {
                export const PERMISSIONS = ['auth.access_view_dqrt_audit']
                export const SEND_TO_FIX = ['auth.edit_dqrt_send_to_fix']
                export const COMMENT_ON_THREAD = ['auth.edit_dqrt_audit_thread']
                export const ELEVATED_VIEW = ['auth.view_dqrt_elevated_audit_features']
                export const SWITCH_VIEW = ['auth.switch_dqrt_audit_view']
                export const VIEW_RESTRICTED_COLUMNS = ['auth.view_dqrt_audit_restricted_columns']
                export const CUSTOMIZE = ['auth.customize_dqrt_audit_view']
                export const EDIT = ['auth.edit_dqrt_audit']
            }
            export namespace RuleBook {
                export const PERMISSIONS = ['auth.access_view_dqrt_rulebook']
                export const EDIT = ['auth.edit_dqrt_rulebook']
            }
        }

        export namespace UtilityIdentification {
            export const PERMISSIONS = ['auth.access_app_utility_identification']
        }
    }
    export namespace ResistanceSampling {
        export const PERMISSIONS = ['auth.access_app_sampling']
        export const PRINT_QR_CODE = ['auth.access_view_resistance_sampling_qr_print']

        export namespace SampleDemand {
            export const PERMISSIONS = ['auth.access_sampling_demand']
            export namespace Create {
                export const ANY_PERMISSIONS = ['auth.access_resistance_sampling_demand_create']
                export const ENABLE_DISABLE_TRIAL = ['auth.toggle_enable_disable_sample_demand_trial']
                export const SHIP_EQUIPMENT = ['auth.ship_sampling_equipment']
                export const EDIT_SUBSAMPLE_COUNT = ['auth.edit_fta_subsample_sampling_count']
            }
            export namespace TrialAssignment {
                export const ANY_PERMISSIONS = ['auth.access_view_resistance_sampling_trial_assignment']
            }

            export namespace Report {
                export const PERMISSIONS = ['auth.access_view_resistance_sampling_report']

                export const VIEW_PROFORMA_EDITOR = ['auth.access_sampling_proforma_editor']
            }
            export namespace PathogenDictionary {
                export const PERMISSIONS = ['auth.access_sampling_pathogen_dict']
            }
        }

        export namespace SampleAnalysis {
            export const ANY_PERMISSIONS = ['auth.access_view_resistance_sampling_sample_analysis']
        }
    }


    export namespace Equipment {
        export const PERMISSIONS = ['auth.access_app_digital_inv']
        export const VIEW_ALL_COUNTRIES = ['auth.view_digital_inv_all_countries']
        export const VIEW_ALL_SITES_IN_COUNTRY = ['auth.view_digital_inv_all_sites']
        export const PRINT_QR_CODE = ['auth.access_view_digital_inv_qr_print']
        export const CREATE_QR_CODE = ['auth.create_digital_inv_qr_code']
        export namespace Devices {
            export const PERMISSIONS = ['auth.access_view_digital_inv_devices']
            export const EDIT_DEVICE = ['auth.edit_digital_inv_device']
            export const EDIT_OVERRIDE_DEVICE = ['auth.edit_override_digital_inv_device']
            export const EDIT_DEVICE_ATTACHMETS = ['auth.edit_digital_inv_attachment']
            export const DELETE_DEVICE = ['auth.delete_digital_inv_device']
            export const ARCHIVE_DEVICE = ['auth.archive_digital_inv_device']
            export namespace AllDevices {
                export const PERMISSIONS = ['auth.access_view_digital_inv_all_devices']
            }
        }
        export namespace DeviceApproval {
            export const PERMISSIONS = ['auth.access_view_digital_inv_device_approval']
            export const EDIT_DEVICE_APPROVAL = ['auth.edit_digital_inv_device_approval']
            export const EDIT_APPROVAL_ELEVATED = ['auth.edit_digital_inv_device_approval_elevated']
            /**
             * Meant for generic user to access admin features, and admin to view and access elevated edit.
             * Should come before `edit_digital_inv_device_approval_elevated`
             * */
            export const VIEW_EDIT_APPROVAL_ELEVATED = ['auth.view_edit_digital_inv_device_approval_elevated']
        }
        export namespace ReportManager {
            export const PERMISSIONS = ['auth.access_view_digital_inv_report_mngr']
            export const EDIT = ['auth.edit_digital_inv_report_mngr']
        }
        export namespace Valenco {
            export const PERMISSIONS = ['auth.access_app_digital_inv_valenco']
        }
        export const ANY_APPROVE_REJECT_REQUEST = ['equipments_stock.approve_reject_request', ...user.FS, user.MANAGEMENT_LEAD, ...user.ADMIN_EQUIPMENT, ...user.EQUIPMENT_GENERIC]
        export const ANY_ADD_DEVICE_INFORMATION = ['equipments_stock.add_devicestorageinformation', ...user.FS, ...user.EQUIPMENT_GENERIC]

    }


    // add_chemicalorder
    // add_branch_to_branch_chemicalorders
    // accept_branch_to_branch_chemicalorders
    // add_chemicalproductgroupbranch
    // change_chemicalproductgroupbranch
    // view_other_countries_chemicalproductgroupbranch
    // view_other_branches_chemicalproductgroupbranch
    // view_chemicalbranch
    // add_chemicalbranch
    // view_chemicalbranch_list
    // add_chemicalbranch_list
    // view_all_branch_users
    // view_locationcountrybranch
    // access_chemicals_app


    export namespace Chemicals {
        export const PERMISSIONS = ['auth.access_app_chemicals']

        export namespace Products {

            export namespace Add {
                export const CREATE = ['auth.add_chemicals_inv_productgroupbranch']
                export const CHANGE = ['auth.change_chemicalproductgroupbranch']

                export const PERMISSIONS = ['auth.add_chemicals_inv_productgroupbranch']
            }
        }
        export namespace Orders {
            export const ADD = ['auth.add_chemical_inv_order']
            export const PERMISSIONS = ['auth.add_chemicalorder']

            export const ADD_BRANCH_TO_BRANCH = ['auth.add_chemicals_inv_branch_to_branch_order']
            export const ACCEPT_BRANCH_TO_BRANCH = ['auth.accept_chemicals_inv_branch_to_branch_orders']

        }

        export namespace Branches {

            export const VIEW = ['auth.view_chemicalbranch']
            export const ADD = ['auth.add_chemicalbranch']

            export const ANY_PERMISSIONS = ['auth.view_chemicalbranch']
            export const VIEW_BRANCHES_FROM_OTHER_COUNTRIES = ['auth.view_chemicals_inv_other_cty_branch']

            export const VIEW_OTHER_COUNTRIES = ['auth.view_other_countries_chemicalproductgroupbranch']
            export const VIEW_OTHER_BRANCHES = ['auth.view_other_branches_chemicalproductgroupbranch']
            export const EDIT_BRANCH = ['auth.edit_chemicals_inv_branch']
            /**Edit branch not belonging to the admin */
            export const EDIT_OTHER_BRANCH = ['auth.edit_other_chemicals_inv_branch']

            export namespace List {
                export const ADD_LIST = ['auth.add_chemicalbranch_list']
                export const VIEW_LIST = ['auth.view_chemicalbranch_list']
                export const VIEW_LOCATION_COUNTRY_BRANCH = ['auth.view_chemicals_inv_localcountrybranch']
                export const PERMISSIONS = ['auth.view_chemicalbranch_list']
            }

        }

        export namespace Tracking {
            export const ANY_PERMISSIONS = [user.MANAGEMENT_LEAD, user.MANAGE_FROST, user.FROST_GENERIC, user.MANAGEMENT_LEAD, user.FS, user.FROST_FS_COUNTRY_LEAD]
        }
    }


    export namespace Activity {
        export const PERMISSIONS = ['auth.access_app_activity_planner']
        export const VIEW_GLOBAL_ACTIVITYES = ['auth.view_activity_planner_global_activities']
        export const VIEW_TTL_ACTIVITYES = ['auth.view_activity_planner_ttl_activities']
        export const EDIT = ['auth.edit_activity_planner_activity']
    }







    export namespace People {
        export const PERMISSIONS = ['auth.access_app_addressbook']
        export const EDIT_DEFAULT_MODULE_ADDRESS = ['auth.edit_addressbook_default_module_addr']
        export const EDIT_USER_DETAILS = ['auth.edit_addressbook_user']
        export const SWITCH_TO_ANY_USER = ['auth.switch_to_any_user']
        export const VIEW_PARAMETERS = ['auth.view_addressbook_parameters']
        export const EDIT_PARAMETERS = ['auth.edit_addressbook_parameters']
        export const EDIT_REGION_PERMISSIONS = ['auth.edit_region_permissions']
        export const BULK_EDIT = ['auth.bulk_edit_addressbook']
        export const VIEW_ADDRESSBOOK_SHIPPING = ['auth.view_addressbook_shipping_accounts']
    }

    export namespace Settings {
        export const ANY_PERMISSIONS = ['auth.access_app_settings']
        export namespace Developer {
            export const PERMISSIONS = ['auth.access_app_settings_developer']
            export const EDIT = ['auth.edit_app_settings_developer']
        }
        export namespace FROST {
            export const PERMISSIONS = ['auth.access_app_settings_frost']
            export const EDIT = ['auth.edit_app_settings_frost']
        }
        export namespace Seedcare {
            export const PERMISSIONS = ['auth.access_app_settings_seedcare']
            export const EDIT = ['auth.edit_app_settings_seedcare']
        }
        export namespace DigitalInv {
            export const PERMISSIONS = ['auth.access_app_settings_digital_inv']
            export const EDIT = ['auth.edit_app_settings_digital_inv']
        }
        export namespace ResistanceSampling {
            export const PERMISSIONS = ['auth.access_app_settings_resistance_sampling']
            export const EDIT = ['auth.edit_app_settings_resistance_sampling']
        }
        export namespace DataQuality {
            export const PERMISSIONS = ['auth.access_app_settings_data_quality']
            export const EDIT = ['auth.edit_app_settings_data_quality']
        }
        export namespace ChemicalInv {
            export const PERMISSIONS = ['auth.access_app_settings_chemicals_inv']
            export const EDIT = ['auth.edit_app_settings_chemicals_inv']
        }
    }


}